module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/share.json
// module id = 537
// module chunks = 10